import * as React from 'react'
function SvgList(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M28.564 23.919a2.073 2.073 0 012.903.414 2.201 2.201 0 01-.386 3.04l-9.001 7.2c-.427.214-.853.427-1.28.427-.427 0-.853-.213-1.28-.427l-9-7.2a2.201 2.201 0 01-.35-3.086 2.073 2.073 0 012.913-.332l7.717 6.138 7.717-6.138.047-.036zM19.52 5.56c.64-.64 1.92-.64 2.56 0l9 7.2c.93.743 1.1 2.089.387 3.04l-.036.047a2.073 2.073 0 01-2.914.332L20.8 10.04l-7.717 6.139a2.074 2.074 0 01-2.95-.379 2.201 2.201 0 01.386-3.04l9.001-7.2z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgList
